import React from "react";
import { StyleSheet, View, Pressable } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";

interface TabData {
  key: string;
  title: string;
}

interface CourseStudentTabNavigatorProps {
  tabData: TabData[];
  activeTab: string;
  onTabPress: (tabKey: string) => void;
}

const CourseStudentTabNavigator: React.FC<CourseStudentTabNavigatorProps> = ({ tabData, activeTab, onTabPress }) => {
  return (
    <View style={styles.tabContainer} accessibilityRole="tablist">
      {tabData.map((tab) => {
        const isActive = activeTab === tab.key;

        return (
          <Pressable
            key={tab.key}
            accessibilityLabel={tab.title}
            style={[styles.tab, isActive && styles.activeTab]}
            accessibilityRole="tab"
            onPress={() => onTabPress(tab.key)}>
            <CustomText
              text={tab.title}
              size="s"
              weight={isActive ? "bold" : "normal"}
              style={[styles.tabText, isActive ? styles.activeTabText : styles.inactiveTabText]}
              useTranslationText={false}
            />
          </Pressable>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  tabContainer: {
    flexDirection: "row",
    gap: 12,
    marginBottom: 12,
  },
  tab: {
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 8,
  },
  activeTab: {
    backgroundColor: "#EAECF0",
  },
  tabText: {
    fontSize: 14,
  },
  activeTabText: {
    color: "#344054",
    fontWeight: "700",
  },
  inactiveTabText: {
    color: "#667085",
    fontWeight: "400",
  },
});

export default CourseStudentTabNavigator;
